import { cn } from '@/lib/utils'

export type DocumentStatus =
  | 'draft'
  | 'issued'
  | 'sent'
  | 'paidPartially'
  | 'paid'
  | 'overpaid'
  | 'overdue'
  | 'cancelled'
  | 'refunded'
  | 'pending'
  | 'matched'
  | 'unmatched'
  | 'active'
  | 'inactive'
  | 'low'
  | 'out'

const toneByStatus: Record<string, string> = {
  draft: 'bg-neutral-bg text-muted-foreground',
  issued: 'bg-neutral-bg text-foreground',
  sent: 'bg-info-bg text-info',
  pending: 'bg-warning-bg text-warning',
  paidPartially: 'bg-warning-bg text-warning',
  paid: 'bg-success-bg text-success',
  overpaid: 'bg-success-bg text-success',
  matched: 'bg-success-bg text-success',
  overdue: 'bg-danger-bg text-danger',
  unmatched: 'bg-warning-bg text-warning',
  cancelled: 'bg-neutral-bg text-muted-foreground line-through decoration-1',
  refunded: 'bg-neutral-bg text-muted-foreground',
  active: 'bg-success-bg text-success',
  inactive: 'bg-neutral-bg text-muted-foreground',
  low: 'bg-warning-bg text-warning',
  out: 'bg-danger-bg text-danger',
}

export interface StatusBadgeProps {
  status: DocumentStatus | string | undefined | null
  label?: string
  className?: string
}

/** Tlumený stavový odznak s tečkou (Attio tóny). */
export const StatusBadge = ({ status, label, className }: StatusBadgeProps) => {
  if (!status) return null
  return (
    <span
      className={cn(
        'inline-flex h-5 items-center gap-1.5 rounded-full px-2 text-xs font-medium whitespace-nowrap',
        toneByStatus[status] ?? 'bg-neutral-bg text-muted-foreground',
        className,
      )}
    >
      <span className="size-1.5 rounded-full bg-current opacity-80" aria-hidden />
      {label ?? status}
    </span>
  )
}
